import React from 'react';
import { SectionFade } from './ui/SectionFade';
const steps = [{
  num: '1',
  desc: 'Descarga el manual y la guía de bolsillo en tu dispositivo.'
}, {
  num: '2',
  desc: 'Aplica el Protocolo de los 5 Segundos en tu próxima compra.'
}, {
  num: '3',
  desc: "Sustituye los 'impostores' por comida real y siente el cambio en tu energía en 7 días."
}];
export function ThreeSteps() {
  return <section className="py-24 px-4 bg-brand-black border-y border-white/5" data-id="element-160">
      <div className="max-w-5xl mx-auto" data-id="element-161">
        <SectionFade data-id="element-162">
          <h2 className="font-bebas text-6xl md:text-8xl text-center mb-20 tracking-tight" data-id="element-163">
            CÓMO FUNCIONA EN <span className="text-brand-neon" data-id="element-164">3 PASOS:</span>
          </h2>
        </SectionFade>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8 relative" data-id="element-165">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-1/6 right-1/6 h-0.5 bg-white/10 z-0" data-id="element-166"></div>

          {steps.map((step, index) => <SectionFade key={index} delay={index * 0.2} className="relative z-10" data-id="element-167">
              <div className="flex flex-col items-center text-center group" data-id="element-168">
                <div className="w-24 h-24 rounded-full bg-brand-dark border-2 border-brand-neon flex items-center justify-center mb-8 shadow-[0_0_15px_rgba(200,255,0,0.2)] group-hover:shadow-[0_0_25px_rgba(200,255,0,0.4)] transition-shadow" data-id="element-169">
                  <span className="font-bebas text-5xl text-brand-neon" data-id="element-170">
                    {step.num}
                  </span>
                </div>
                <p className="font-inter text-xl text-gray-300 leading-relaxed max-w-xs" data-id="element-171">
                  {step.desc}
                </p>
              </div>
            </SectionFade>)}
        </div>
      </div>
    </section>;
}